import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import {
  ReportDesignerItemSpacer,
  ReportDesignItemSpacerConfig
} from "../../report-design-item";

@Component({
  selector: "snt-report-designer-spacer",
  templateUrl: "report-designer-spacer.component.html",
  styles: [
    `
      :host {
        display: flex;
        flex: 1;
      }
    `
  ],
  standalone: false
})
export class ReportDesignerSpacerComponent implements OnInit {
  @Input() item!: ReportDesignerItemSpacer;
  @Input() level!: number;
  @Input() parentName!: string;

  @Output() config: EventEmitter<ReportDesignItemSpacerConfig> =
    new EventEmitter();

  formData: {
    size: string | undefined;
    separator: boolean | undefined;
    dashed: boolean | undefined;
  } = {
    size: undefined,
    separator: undefined,
    dashed: undefined
  };

  ngOnInit(): void {
    this.formData.size = this.item.config.size || undefined;
    this.formData.separator = this.item.config.separator || undefined;
    this.formData.dashed = this.item.config.dashed || undefined;
  }

  onFieldDataChanged(): void {
    this.config.emit(this.formData);
  }

  async renderPdfObject(): Promise<Record<string, any>> {
    return {
      type: "spacer",
      config: {
        size: this.formData.size,
        separator: this.formData.separator || false
      }
    };
  }
}
